var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPrinter24(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 11.5a.75.75 0 100-1.5.75.75 0 000 1.5zm3.75-.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 6v1.5H5A1.5 1.5 0 003.5 9v7A1.5 1.5 0 005 17.5h1.5V20A1.5 1.5 0 008 21.5h8a1.5 1.5 0 001.5-1.5v-2.5H19a1.5 1.5 0 001.5-1.5V9A1.5 1.5 0 0019 7.5h-1.5V6A1.5 1.5 0 0016 4.5H8A1.5 1.5 0 006.5 6zM8 5.5a.5.5 0 00-.5.5v1.5h9V6a.5.5 0 00-.5-.5H8zm9.5 11H19a.5.5 0 00.5-.5V9a.5.5 0 00-.5-.5H5a.5.5 0 00-.5.5v7a.5.5 0 00.5.5h1.5v-1.998h11V16.5zM7.5 20v-4.498h9V20a.5.5 0 01-.5.5H8a.5.5 0 01-.5-.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrinter24);
export default __webpack_public_path__ + "static/media/icon-printer-24.64787e04.svg";
export { ForwardRef as ReactComponent };